import ModelValidator       from "../../../validation/validators/ModelValidator";

import reservee_form__rules from "../../../validation/scenarios/reservee_form__rules";
import step_1               from "./step_1";
import step_2               from "./step_2";
import step_3 from "./step_3";
import fields from "./fields";

export default {
    fields,
    validators: {
        step_1       : new ModelValidator(step_1),
        step_2       : new ModelValidator(step_2),
        step_3       : new ModelValidator(step_3),
        reservee_form: new ModelValidator(reservee_form__rules)
    }
}
